var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown',{staticClass:"category_dropdown m-2",attrs:{"left":"","text":_vm.title,"size":"sm"}},_vm._l((_vm.options),function(item,key){return _c('b-dropdown-item',{key:key},[_c('router-link',{attrs:{"to":item.value}},[_c('i',{class:item.icon}),_c('span',{domProps:{"textContent":_vm._s(item.text)}})])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }